import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { MaterialDropdown, MaterialObjectSelection, } from 'console/shared/components/fields';
import { BoilerAdapter, HeatingCircuit } from 'z3k-config';
import memoizeOne from 'memoize-one';
import { c2k, removeNulls } from 'utils';
import { Control } from 'console/shared/components/fields/control';
// кодируется нулевой температурой по цельсию,
// а у в конфиге в децикельвинах!
// (273 + t) * 10 = 2730 + t * 10
const temps = [30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95].map((temp) => ({
    text: `Температура ТН = ${temp}°C`,
    value: temp * 10,
}));
const tempTH = [
    { text: 'Требуемая t° ТН', value: c2k(0) },
    ...[5, 10, 15, 20, 25, 30, 35, 40, 45].map((temp) => ({
        text: `Требуемая t° ТН +${temp}°`,
        value: c2k(temp),
    })),
];
export const heatRequestOptions = memoizeOne((heat_request) => removeNulls([
    { text: 'Не используется', value: 0 },
    heat_request === HeatingCircuit.TARGET_BOILER_TEMPERATURE_REQUEST
        ? {
            text: 'Целевая температура котла',
            value: HeatingCircuit.TARGET_BOILER_TEMPERATURE_REQUEST,
        }
        : null,
    {
        text: 'Максимальная температура контура',
        value: HeatingCircuit.HEAT_REQUEST__MAX_BOILER_TEMP,
    },
    ...tempTH,
    ...temps,
]));
function HeatRequestFieldImpl(props) {
    const { heating_circuit, service_view, device_spec, withBoilerAdapter, isFlowType, boiler_circuit_boiler_group_options, heatSourceEditingProps, heatRequestEditingProps, config, } = props;
    //issues #1186
    const connect_plus_show_heat_request_with_air = useMemo(() => HeatingCircuit.isAirConsumerMode(heating_circuit)
        ? device_spec.heating.has_heating &&
            device_spec.heating.has_extended_heating.show_heat_request_with_air
        : true, [heating_circuit, device_spec]);
    const field = useCallback((input_props) => (_jsx(MaterialDropdown, { ...input_props, options: heatRequestOptions(heating_circuit.heat_request), disabled: HeatingCircuit.isFlowDHW(heating_circuit) })), [heating_circuit, heatRequestOptions]);
    const options_count = useMemo(() => boiler_circuit_boiler_group_options.flatMap((x) => x.options).length, [boiler_circuit_boiler_group_options]);
    const has_boiler_adapter = useMemo(() => {
        const adapters = BoilerAdapter.get.idIn(config, heating_circuit.control_devices);
        return adapters.length > 0;
    }, [heating_circuit.control_devices, config.boiler_adapters]);
    const show_heat_source_dhw = useMemo(() => {
        if (HeatingCircuit.isDHW(heating_circuit)) {
            return !has_boiler_adapter;
        }
        return true;
    }, [heating_circuit.type, has_boiler_adapter]);
    if (HeatingCircuit.isBoiler(heating_circuit) ||
        HeatingCircuit.isCooling(heating_circuit) ||
        !service_view ||
        !device_spec.heating.has_heating) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [(!(withBoilerAdapter && isFlowType) ||
                heating_circuit.control_devices.length === 0) &&
                connect_plus_show_heat_request_with_air && (_jsx(Control, { label: "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0442\u0435\u043F\u043B\u043E", ...heatRequestEditingProps, field: field, help_id: "heating_circuits_heat_request" })), heating_circuit.heat_request != null &&
                options_count > 1 &&
                show_heat_source_dhw && (_jsx(MaterialObjectSelection, { label: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u0442\u0435\u043F\u043B\u0430", notChosenTitle: "\u0412\u0441\u0435 \u0442\u0435\u043F\u043B\u043E\u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u044B", help_id: "heating_circuits_heat_source", options: boiler_circuit_boiler_group_options, ...heatSourceEditingProps }))] }));
}
export const HeatRequestField = memo(HeatRequestFieldImpl);
